import origRefresh from "@assets/redesign/icons/refresh.svg";
import wlpRefresh from "@components/WLP202603/assets/redesign/icons/refresh.svg";
import wlpRefreshEditor from "@components/WLP202603/assets/redesign/icons/refreshEditor.svg";
import Icon from "@components/global/new/Icon/Icon";
import mainLocationsStore from "@mobx/store/locations";
import unallocatedMinersStore from "@mobx/store/locations/unallocated";
import { observer } from "mobx-react-lite";
import { CSSProperties, useCallback } from "react";
import styles from "./RefreshRacks.module.scss";
import { WLP202603 } from "../../../config";

const refresh = (variant?: string) => !WLP202603 ? origRefresh : variant === "editor" ? wlpRefreshEditor : wlpRefresh;

export interface IRefreshRacks3Props {
  style?: CSSProperties;
  variant?: "default" | "editor";
}

const useControl = (
  props: IRefreshRacks3Props
) => {
  const buildingStore = mainLocationsStore.activeLocation?.activeBuilding;

  const onRefresh = () => {
    onRefreshRacks();
  };

  const onRefreshRacks = useCallback(async () => {
    buildingStore?.reload();
    unallocatedMinersStore.reload();
  }, [buildingStore]);

  return {
    onRefresh,
  };
};


const RefreshRacks3 = observer((props: IRefreshRacks3Props) => {
  const control = useControl(props);
  const className = props.variant === "editor"
    ? `${styles.wrapper} ${styles.editorVariant}`
    : styles.wrapper;
  return (
    <div className={className} onClick={control.onRefresh} style={props.style}>
      <Icon className={styles.icon} src={refresh(props.variant)} noHover />
    </div>
  );
})

RefreshRacks3.displayName = "RefreshRacks3";

export default RefreshRacks3;
